export default __webpack_public_path__ + "static/media/CloseCircle.1d9bf6cd.svg";